//import { DEV_MODE } from "@env";

//const serverURL = DEV_MODE === 'production' ? 'https://api.nmoment.live' : 'http://192.168.219.100:5050'
// const serverURL = 'http://192.168.219.102:5050'
const serverURL = 'https://api.npick.studio'


export default serverURL